// AdminHelpDesk.jsx - Complete with Tabs for Support & Contact Form
import React, { useState, useEffect, useRef } from 'react';
import {
  FaTicketAlt,
  FaSearch,
 
  FaFilter,
  FaComments,
  FaPaperclip,
  FaClock,
  FaCheckCircle,
  FaExclamationCircle,
  FaCircle,
  FaFileAlt,
  FaPaperPlane,
  FaTimes,
  FaChevronLeft,
  FaChevronRight,
  FaUser,
  FaCalendarAlt,
  FaSpinner,
  FaDownload,
  FaUserCheck,
  FaUserPlus,
  FaEye,
  FaUserTie,
  FaRegClock,
  FaCog,
  FaFileImage,
  FaFilePdf,
  FaExpand,
  FaInfoCircle,
  FaComments as FaCommentsIcon,
  FaTag,
  FaEnvelope,
  FaPhone,
  FaReply,
  

 
} from 'react-icons/fa';
import withauth from '../../auth/WithAuth';
import './support.scss';
import Nav from '../../../components/layout/Nav';
import { toast } from 'react-toastify';
import { serverUrlAuth } from '../../../serverUrl';

const STATUSES = [
  { value: 'open', label: 'Open', icon: '🟢', color: '#3b82f6' },
  { value: 'pending', label: 'Pending', icon: '🟡', color: '#f59e0b' },
  { value: 'resolved', label: 'Resolved', icon: '✅', color: '#10b981' },
  { value: 'closed', label: 'Closed', icon: '🔒', color: '#6b7280' },
];

const CONTACT_STATUSES = [
  { value: 'pending', label: 'Pending', icon: '🟡', color: '#f59e0b' },
  { value: 'in_progress', label: 'In Progress', icon: '🔵', color: '#3b82f6' },
  { value: 'resolved', label: 'Resolved', icon: '✅', color: '#10b981' },
  { value: 'closed', label: 'Closed', icon: '🔒', color: '#6b7280' },
];

const PRIORITIES = [
  { value: 'low', label: 'Low', color: '#6b7280' },
  { value: 'medium', label: 'Medium', color: '#f59e0b' },
  { value: 'high', label: 'High', color: '#ef4444' },
  { value: 'urgent', label: 'Urgent', color: '#dc2626' },
];

const ISSUE_TYPES = [
  { value: 'complaint', label: 'Complaint' },
  { value: 'suggestion', label: 'Suggestion' },
];

// Polling intervals
const TICKET_POLLING_INTERVAL = 30000;
const CHAT_POLLING_INTERVAL = 5000;

const AdminHelpDesk = () => {
  // ─── Tab State ───────────────────────────────
  const [activeTab, setActiveTab] = useState('support'); // 'support' | 'contact'

  // ─── Support Ticket State ────────────────────
  const [tickets, setTickets] = useState([]);
  const [filteredTickets, setFilteredTickets] = useState([]);
  const [selectedTicket, setSelectedTicket] = useState(null);
  const [showTicketDetails, setShowTicketDetails] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [statusFilter, setStatusFilter] = useState('all');
  const [priorityFilter, setPriorityFilter] = useState('all');
  const [issueTypeFilter, setIssueTypeFilter] = useState('all');
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [newMessage, setNewMessage] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const [stats, setStats] = useState(null);
  const [assigning, setAssigning] = useState(false);
  const [assigningTicketId, setAssigningTicketId] = useState(null);

  // ─── Contact Form Ticket State ──────────────
  const [contactTickets, setContactTickets] = useState([]);
  const [filteredContactTickets, setFilteredContactTickets] = useState([]);
  const [selectedContactTicket, setSelectedContactTicket] = useState(null);
  const [showContactTicketDetails, setShowContactTicketDetails] = useState(false);
  const [contactSearchTerm, setContactSearchTerm] = useState('');
  const [contactStatusFilter, setContactStatusFilter] = useState('all');
  const [contactCurrentPage, setContactCurrentPage] = useState(1);
  const [contactItemsPerPage, setContactItemsPerPage] = useState(10);
  const [contactReplyMessage, setContactReplyMessage] = useState('');
  const [isContactSubmitting, setIsContactSubmitting] = useState(false);
  const [contactStats, setContactStats] = useState(null);
  const [isContactLoading, setIsContactLoading] = useState(true);

  // ─── Polling states ──────────────────────────
  const [isPollingTickets, setIsPollingTickets] = useState(true);
  const [isPollingChat, setIsPollingChat] = useState(true);
  const [lastTicketUpdate, setLastTicketUpdate] = useState(null);
  const [lastChatUpdate, setLastChatUpdate] = useState(null);
  const [newTicketsCount, setNewTicketsCount] = useState(0);
  const [chatNewMessagesCount, setChatNewMessagesCount] = useState(0);

  // ─── Refs ────────────────────────────────────
  const ticketPollingTimeoutRef = useRef(null);
  const chatPollingTimeoutRef = useRef(null);
  const isTicketPollingRef = useRef(true);
  const isChatPollingRef = useRef(true);
  const previousTicketsRef = useRef([]);

  // ─── Attachment preview states ──────────────
  const [selectedAttachment, setSelectedAttachment] = useState(null);
  const [showAttachmentPreview, setShowAttachmentPreview] = useState(false);
  

  // ─── Utility Functions ──────────────────────────

const formatDate = (dateString) => {
  if (!dateString) return 'N/A';
  const date = new Date(dateString);
  return date.toLocaleDateString('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
};

// Add this function
const formatTime = (dateString) => {
  if (!dateString) return '';
  const date = new Date(dateString);
  return date.toLocaleTimeString('en-US', {
    hour: '2-digit',
    minute: '2-digit',
  });
};




  // ─── Mobile tab state ────────────────────────
  const [mobileDetailTab, setMobileDetailTab] = useState('details');

  // ─── Responsive items per page ──────────────
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 768) {
        setItemsPerPage(5);
        setContactItemsPerPage(5);
      } else {
        setItemsPerPage(10);
        setContactItemsPerPage(10);
      }
    };
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // ─── Initial Data Fetch ─────────────────────
  useEffect(() => {
    if (activeTab === 'support') {
      fetchTickets();
      fetchStats();
      startTicketPolling();
      startChatPolling();
    } else {
      fetchContactTickets();
      // fetchContactStats();
    }

    return () => {
      stopTicketPolling();
      stopChatPolling();
    };
  }, [activeTab]);

  // ─── Polling for support tickets ────────────
  useEffect(() => {
    if (activeTab === 'support') {
      startTicketPolling();
      startChatPolling();
    } else {
      stopTicketPolling();
      stopChatPolling();
    }
  }, [activeTab]);

  // ============================================================
  // SUPPORT TICKET FUNCTIONS
  // ============================================================

  // ─── Ticket Polling ──────────────────────────
  const startTicketPolling = () => {
    isTicketPollingRef.current = true;
    setIsPollingTickets(true);
    if (ticketPollingTimeoutRef.current) {
      clearTimeout(ticketPollingTimeoutRef.current);
    }
    pollForTicketUpdates();
  };

  const stopTicketPolling = () => {
    isTicketPollingRef.current = false;
    setIsPollingTickets(false);
    if (ticketPollingTimeoutRef.current) {
      clearTimeout(ticketPollingTimeoutRef.current);
      ticketPollingTimeoutRef.current = null;
    }
  };

  const pollForTicketUpdates = async () => {
    if (!isTicketPollingRef.current || activeTab !== 'support') return;

    try {
      const response = await serverUrlAuth.get('helpdesk/admin/tickets/');
      const newTickets = response.data;

   

    

      previousTicketsRef.current = tickets;
      setTickets(newTickets);
      setLastTicketUpdate(new Date());

      if (selectedTicket && showTicketDetails) {
        const updatedSelected = newTickets.find(
          (t) => t.id === selectedTicket.id,
        );
        if (updatedSelected) {
          setSelectedTicket((prev) => ({
            ...prev,
            ...updatedSelected,
            replies: prev.replies || updatedSelected.replies,
          }));
        }
      }

      if (Math.random() < 0.5) {
        fetchStats();
      }
    } catch (err) {
      console.warn('Ticket polling error:', err);
    } finally {
      if (isTicketPollingRef.current) {
        ticketPollingTimeoutRef.current = setTimeout(
          pollForTicketUpdates,
          TICKET_POLLING_INTERVAL,
        );
      }
    }
  };

  // ─── Chat Polling ────────────────────────────
  const startChatPolling = () => {
    isChatPollingRef.current = true;
    setIsPollingChat(true);
    if (chatPollingTimeoutRef.current) {
      clearTimeout(chatPollingTimeoutRef.current);
    }
    pollForChatUpdates();
  };

  const stopChatPolling = () => {
    isChatPollingRef.current = false;
    setIsPollingChat(false);
    if (chatPollingTimeoutRef.current) {
      clearTimeout(chatPollingTimeoutRef.current);
      chatPollingTimeoutRef.current = null;
    }
  };

  const pollForChatUpdates = async () => {
    if (!isChatPollingRef.current || activeTab !== 'support') return;

    if (selectedTicket && showTicketDetails) {
      try {
        const response = await serverUrlAuth.get(
          `helpdesk/admin/tickets/${selectedTicket.id}/`,
        );
        const updatedTicket = response.data;

        const oldReplyCount = selectedTicket.replies
          ? selectedTicket.replies.length
          : 0;
        const newReplyCount = updatedTicket.replies
          ? updatedTicket.replies.length
          : 0;

        if (newReplyCount > oldReplyCount) {
          const newMessages = newReplyCount - oldReplyCount;
          setChatNewMessagesCount((prev) => prev + newMessages);
          setSelectedTicket(updatedTicket);
          setLastChatUpdate(new Date());
          setTickets((prev) =>
            prev.map((t) => (t.id === updatedTicket.id ? updatedTicket : t)),
          );
        } else {
          setSelectedTicket((prev) => ({
            ...prev,
            ...updatedTicket,
            replies: prev.replies || updatedTicket.replies,
          }));
        }
      } catch (err) {
        console.warn('Chat polling error:', err);
      }
    }

    if (isChatPollingRef.current) {
      chatPollingTimeoutRef.current = setTimeout(
        pollForChatUpdates,
        CHAT_POLLING_INTERVAL,
      );
    }
  };

  // ─── Fetch Support Tickets ──────────────────
  const fetchTickets = async () => {
    setIsLoading(true);
    setError(null);
    try {
      const response = await serverUrlAuth.get('helpdesk/admin/tickets/');
      setTickets(response.data);
      setFilteredTickets(response.data);
      setLastTicketUpdate(new Date());
      setNewTicketsCount(0);
    } catch (err) {
      setError(err.response?.data?.detail || 'Failed to load tickets');
      toast.error('Failed to load tickets');
    } finally {
      setIsLoading(false);
    }
  };

  const fetchStats = async () => {
    try {
      const response = await serverUrlAuth.get('helpdesk/admin/tickets/stats/');
      setStats(response.data);
    } catch (err) {
      console.warn('Could not fetch stats:', err);
    }
  };

  // ─── Support Ticket Handlers ─────────────────
  const handleViewTicket = async (ticketId) => {
    try {
      setIsLoading(true);
      const response = await serverUrlAuth.get(
        `helpdesk/admin/tickets/${ticketId}/`,
      );
      setSelectedTicket(response.data);
      setChatNewMessagesCount(0);
      setShowTicketDetails(true);
      setMobileDetailTab('details');
    } catch (err) {
      toast.error('Failed to load ticket details');
    } finally {
      setIsLoading(false);
    }
  };

  const handleCloseTicketDetails = () => {
    setShowTicketDetails(false);
    setSelectedTicket(null);
    setNewMessage('');
    setMobileDetailTab('details');
    setChatNewMessagesCount(0);
  };

  const handleSendReply = async () => {
    if (!newMessage.trim()) return;

    setIsSubmitting(true);
    try {
      await serverUrlAuth.post(
        `helpdesk/admin/tickets/${selectedTicket.id}/reply/`,
        { message: newMessage.trim() },
      );

      const updatedTicket = await serverUrlAuth.get(
        `helpdesk/admin/tickets/${selectedTicket.id}/`,
      );
      setSelectedTicket(updatedTicket.data);
      setTickets((prev) =>
        prev.map((t) =>
          t.id === updatedTicket.data.id ? updatedTicket.data : t,
        ),
      );
      setNewMessage('');
      setChatNewMessagesCount(0);
      fetchStats();
      toast.success('Reply sent successfully');
    } catch (err) {
      toast.error(err.response?.data?.detail || 'Failed to send reply');
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleStatusChange = async (status, ticketId) => {
    const targetId = ticketId || selectedTicket?.id;
    if (!targetId) return;

    setIsSubmitting(true);
    try {
      await serverUrlAuth.patch(`helpdesk/admin/tickets/${targetId}/status/`, {
        status: status,
      });

      const updatedTicket = await serverUrlAuth.get(
        `helpdesk/admin/tickets/${targetId}/`,
      );

      if (selectedTicket && targetId === selectedTicket.id) {
        setSelectedTicket(updatedTicket.data);
      }

      setTickets((prev) =>
        prev.map((t) => (t.id === targetId ? updatedTicket.data : t)),
      );

      toast.success('Status updated successfully');
      fetchStats();
    } catch (err) {
      toast.error(err.response?.data?.detail || 'Failed to update status');
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleAssignToMe = async (ticketId) => {
    setAssigningTicketId(ticketId);
    setAssigning(true);
    try {
      await serverUrlAuth.patch(
        `helpdesk/admin/tickets/${ticketId}/assign-to-me/`,
      );

      const updatedTicket = await serverUrlAuth.get(
        `helpdesk/admin/tickets/${ticketId}/`,
      );

      setTickets((prev) =>
        prev.map((t) => (t.id === ticketId ? updatedTicket.data : t)),
      );

      if (selectedTicket && selectedTicket.id === ticketId) {
        setSelectedTicket(updatedTicket.data);
      }

      toast.success('Ticket assigned to you');
      fetchStats();
    } catch (err) {
      toast.error(err.response?.data?.detail || 'Failed to assign ticket');
    } finally {
      setAssigning(false);
      setAssigningTicketId(null);
    }
  };

  // ============================================================
  // CONTACT FORM TICKET FUNCTIONS
  // ============================================================

  const fetchContactTickets = async () => {
    setIsContactLoading(true);
    try {
      const response = await serverUrlAuth.get('helpdesk/admin/contact-tickets/');
      setContactTickets(response.data.data || []);
      setFilteredContactTickets(response.data.data || []);
    } catch (err) {
      toast.error('Failed to load contact form tickets');
      console.error(err);
    } finally {
      setIsContactLoading(false);
    }
  };

  // const fetchContactStats = async () => {
  //   try {
  //     const response = await serverUrlAuth.get('helpdesk/admin/contact-tickets/stats/');
  //     setContactStats(response.data.data);
  //   } catch (err) {
  //     console.warn('Could not fetch contact stats:', err);
  //   }
  // };

  const handleViewContactTicket = async (ticketId) => {
    try {
      setIsContactLoading(true);
      const response = await serverUrlAuth.get(
        `helpdesk/admin/contact-tickets/${ticketId}/`,
      );
      setSelectedContactTicket(response.data.data);
      setShowContactTicketDetails(true);
      setMobileDetailTab('details');
    } catch (err) {
      toast.error('Failed to load ticket details');
    } finally {
      setIsContactLoading(false);
    }
  };

  const handleCloseContactTicketDetails = () => {
    setShowContactTicketDetails(false);
    setSelectedContactTicket(null);
    setContactReplyMessage('');
    setMobileDetailTab('details');
  };

  const handleContactStatusChange = async (status, ticketId) => {
    const targetId = ticketId || selectedContactTicket?.ticket_id;
    if (!targetId) return;

    try {
      await serverUrlAuth.patch(
        `helpdesk/admin/contact-tickets/${targetId}/`,
        { status: status }
      );

      const updatedTicket = await serverUrlAuth.get(
        `helpdesk/admin/contact-tickets/${targetId}/`,
      );

      if (selectedContactTicket && targetId === selectedContactTicket.ticket_id) {
        setSelectedContactTicket(updatedTicket.data.data);
      }

      setContactTickets((prev) =>
        prev.map((t) =>
          t.ticket_id === targetId ? updatedTicket.data.data : t,
        )
      );

      toast.success('Status updated successfully');
      // fetchContactStats();
    } catch (err) {
      toast.error(err.response?.data?.detail || 'Failed to update status');
    }
  };

  const handleSendContactReply = async () => {
    if (!contactReplyMessage.trim() || contactReplyMessage.trim().length < 10) {
      toast.warning('Reply message must be at least 10 characters');
      return;
    }

    setIsContactSubmitting(true);
    try {
      await serverUrlAuth.post(
        `helpdesk/admin/contact-tickets/${selectedContactTicket.ticket_id}/reply/`,
        { reply_message: contactReplyMessage.trim() }
      );

      // Refresh the ticket to get updated status
      const updatedTicket = await serverUrlAuth.get(
        `helpdesk/admin/contact-tickets/${selectedContactTicket.ticket_id}/`,
      );
      setSelectedContactTicket(updatedTicket.data.data);
      
      setContactTickets((prev) =>
        prev.map((t) =>
          t.ticket_id === updatedTicket.data.data.ticket_id 
            ? updatedTicket.data.data 
            : t
        )
      );

      setContactReplyMessage('');
      toast.success('Reply sent to customer via email');
      // fetchContactStats();
    } catch (err) {
      toast.error(err.response?.data?.detail || 'Failed to send reply');
    } finally {
      setIsContactSubmitting(false);
    }
  };

  // ============================================================
  // UTILITY FUNCTIONS
  // ============================================================

  const getStatusLabel = (status) => {
    return status?.charAt(0).toUpperCase() + status?.slice(1) || '';
  };

  const getStatusBadge = (status) => {
    const classes = {
      open: 'status-badge-open',
      pending: 'status-badge-pending',
      resolved: 'status-badge-resolved',
      closed: 'status-badge-closed',
      in_progress: 'status-badge-in-progress',
    };
    return `status-badge ${classes[status] || 'status-badge-open'}`;
  };

  const getPriorityBadge = (priority) => {
    const classes = {
      low: 'priority-low',
      medium: 'priority-medium',
      high: 'priority-high',
      urgent: 'priority-urgent',
    };
    return `priority-badge ${classes[priority] || 'priority-low'}`;
  };

  const getCategoryLabel = (category) => {
    const categories = {
      account: 'My Account',
      projects: 'Projects',
      proposals: 'Proposals',
      payments: 'Payments',
      verification: 'Verification',
      technical: 'Technical Issue',
      password: 'Password Reset',
      notifications: 'Notifications',
      other: 'Other',
    };
    return categories[category] || category;
  };

  const getIssueTypeLabel = (type) => {
    const found = ISSUE_TYPES.find((t) => t.value === type);
    return found ? found.label : type;
  };

  

  const formatDateShort = (dateString) => {
    if (!dateString) return 'N/A';
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', {
      month: 'short',
      day: 'numeric',
    });
  };

  const getStatusColor = (status) => {
    const found = STATUSES.find((s) => s.value === status);
    return found ? found.color : '#6b7280';
  };

  const getContactStatusColor = (status) => {
    const found = CONTACT_STATUSES.find((s) => s.value === status);
    return found ? found.color : '#6b7280';
  };

  const getFileTypeInfo = (filename) => {
    const extension = filename.split('.').pop().toLowerCase();
    const imageTypes = ['jpg', 'jpeg', 'png', 'gif', 'webp', 'svg', 'bmp', 'ico'];
    const pdfTypes = ['pdf'];
    const documentTypes = ['doc', 'docx', 'txt', 'rtf'];
    const spreadsheetTypes = ['xls', 'xlsx', 'csv'];
    const presentationTypes = ['ppt', 'pptx'];
    const archiveTypes = ['zip', 'rar', '7z', 'tar', 'gz'];

    if (imageTypes.includes(extension)) return { type: 'image', icon: FaFileImage, label: 'Image' };
    if (pdfTypes.includes(extension)) return { type: 'pdf', icon: FaFilePdf, label: 'PDF' };
    if (documentTypes.includes(extension)) return { type: 'document', icon: FaFileAlt, label: 'Document' };
    if (spreadsheetTypes.includes(extension)) return { type: 'spreadsheet', icon: FaFileAlt, label: 'Spreadsheet' };
    if (presentationTypes.includes(extension)) return { type: 'presentation', icon: FaFileAlt, label: 'Presentation' };
    if (archiveTypes.includes(extension)) return { type: 'archive', icon: FaFileAlt, label: 'Archive' };
    return { type: 'other', icon: FaFileAlt, label: 'File' };
  };

  const handleAttachmentClick = (attachmentUrl, filename) => {
    setSelectedAttachment({ url: attachmentUrl, filename });
    setShowAttachmentPreview(true);
  };

  const handleCloseAttachmentPreview = () => {
    setShowAttachmentPreview(false);
    setSelectedAttachment(null);
  };

  // ─── Filtering ──────────────────────────────
  useEffect(() => {
    if (activeTab === 'support') {
      let filtered = tickets;

      if (statusFilter !== 'all') {
        filtered = filtered.filter((ticket) => ticket.status === statusFilter);
      }

      if (priorityFilter !== 'all') {
        filtered = filtered.filter((ticket) => ticket.priority === priorityFilter);
      }

      if (issueTypeFilter !== 'all') {
        filtered = filtered.filter((ticket) => ticket.issue_type === issueTypeFilter);
      }

      if (searchTerm) {
        filtered = filtered.filter(
          (ticket) =>
            ticket.subject?.toLowerCase().includes(searchTerm.toLowerCase()) ||
            ticket.ticket_number?.toLowerCase().includes(searchTerm.toLowerCase()) ||
            ticket.created_by_name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
            ticket.category?.toLowerCase().includes(searchTerm.toLowerCase()),
        );
      }

      setFilteredTickets(filtered);
      setCurrentPage(1);
    }
  }, [tickets, searchTerm, statusFilter, priorityFilter, issueTypeFilter, activeTab]);

  // ─── Contact Filtering ──────────────────────
  useEffect(() => {
    if (activeTab === 'contact') {
      let filtered = contactTickets;

      if (contactStatusFilter !== 'all') {
        filtered = filtered.filter((ticket) => ticket.status === contactStatusFilter);
      }

      if (contactSearchTerm) {
        filtered = filtered.filter(
          (ticket) =>
            ticket.ticket_id?.toLowerCase().includes(contactSearchTerm.toLowerCase()) ||
            ticket.first_name?.toLowerCase().includes(contactSearchTerm.toLowerCase()) ||
            ticket.last_name?.toLowerCase().includes(contactSearchTerm.toLowerCase()) ||
            ticket.email?.toLowerCase().includes(contactSearchTerm.toLowerCase()) ||
            ticket.message?.toLowerCase().includes(contactSearchTerm.toLowerCase()),
        );
      }

      setFilteredContactTickets(filtered);
      setContactCurrentPage(1);
    }
  }, [contactTickets, contactSearchTerm, contactStatusFilter, activeTab]);

  // ─── Pagination ─────────────────────────────
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredTickets.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(filteredTickets.length / itemsPerPage);

  const contactIndexOfLastItem = contactCurrentPage * contactItemsPerPage;
  const contactIndexOfFirstItem = contactIndexOfLastItem - contactItemsPerPage;
  const contactCurrentItems = filteredContactTickets.slice(
    contactIndexOfFirstItem,
    contactIndexOfLastItem
  );
  const contactTotalPages = Math.ceil(filteredContactTickets.length / contactItemsPerPage);

  // ─── Render Support Tickets ──────────────────
  const renderSupportTickets = () => {
    if (isLoading && tickets.length === 0) {
      return (
        <div className="loading-container">
          <FaSpinner className="spinner" />
          <p>Loading tickets...</p>
        </div>
      );
    }

    if (error && tickets.length === 0) {
      return (
        <div className="error-container">
          <FaExclamationCircle />
          <h3>Error Loading Tickets</h3>
          <p>{error}</p>
          <button onClick={fetchTickets} className="retry-btn">
            Try Again
          </button>
        </div>
      );
    }

    return (
      <>
        {/* Filters */}
        <div className="filters-container">
          <div className="search-box">
            <FaSearch className="search-icon" />
            <input
              type="text"
              placeholder="Search by ticket number, subject, user, category..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </div>
          <div className="filter-group">
            <div className="filter-item">
              <FaFilter className="filter-icon" />
              <select
                value={statusFilter}
                onChange={(e) => setStatusFilter(e.target.value)}
                className="filter-select"
              >
                <option value="all">All Status</option>
                {STATUSES.map((status) => (
                  <option key={status.value} value={status.value}>
                    {status.label}
                  </option>
                ))}
              </select>
            </div>
            <div className="filter-item">
              <select
                value={priorityFilter}
                onChange={(e) => setPriorityFilter(e.target.value)}
                className="filter-select"
              >
                <option value="all">All Priority</option>
                {PRIORITIES.map((priority) => (
                  <option key={priority.value} value={priority.value}>
                    {priority.label}
                  </option>
                ))}
              </select>
            </div>
            <div className="filter-item">
              <select
                value={issueTypeFilter}
                onChange={(e) => setIssueTypeFilter(e.target.value)}
                className="filter-select"
              >
                <option value="all">All Types</option>
                {ISSUE_TYPES.map((type) => (
                  <option key={type.value} value={type.value}>
                    {type.label}
                  </option>
                ))}
              </select>
            </div>
          </div>
        </div>

        {/* Ticket List */}
        <div className="ticket-list-container">
          {/* Desktop Table View */}
          <div className="ticket-table-wrapper desktop-view">
            <div className="ticket-list-header">
              <div className="header-cell status">Status</div>
              <div className="header-cell ticket">Ticket</div>
              <div className="header-cell user">User</div>
              <div className="header-cell category">Category</div>
              <div className="header-cell priority">Priority</div>
              <div className="header-cell assigned">Assigned To</div>
              <div className="header-cell date">Date</div>
              <div className="header-cell actions">Actions</div>
            </div>

            {currentItems.length === 0 ? (
              <div className="empty-state">
                <FaTicketAlt />
                <h3>No tickets found</h3>
                <p>No tickets match your current filter criteria.</p>
              </div>
            ) : (
              <div className="ticket-list">
                {currentItems.map((ticket) => (
                  <div key={ticket.id} className="ticket-item">
                    <div className="ticket-cell status">
                      <span
                        className="status-dot"
                        style={{ backgroundColor: getStatusColor(ticket.status) }}
                      />
                      <span className={getStatusBadge(ticket.status)}>
                        {getStatusLabel(ticket.status)}
                      </span>
                    </div>
                    <div
                      className="ticket-cell ticket"
                      onClick={() => handleViewTicket(ticket.id)}
                    >
                      <div className="ticket-number">{ticket.ticket_number}</div>
                      <div className="ticket-subject">{ticket.subject}</div>
                    </div>
                    <div
                      className="ticket-cell user"
                      onClick={() => handleViewTicket(ticket.id)}
                    >
                      <div className="user-info">
                        <FaUser />
                        <span>{ticket.created_by_name || 'Unknown'}</span>
                      </div>
                    </div>
                    <div
                      className="ticket-cell category"
                      onClick={() => handleViewTicket(ticket.id)}
                    >
                      <span className="category-badge">
                        {getCategoryLabel(ticket.category)}
                      </span>
                    </div>
                    <div
                      className="ticket-cell priority"
                      onClick={() => handleViewTicket(ticket.id)}
                    >
                      <span className={getPriorityBadge(ticket.priority)}>
                        {ticket.priority}
                      </span>
                    </div>
                    <div
                      className="ticket-cell assigned"
                      onClick={() => handleViewTicket(ticket.id)}
                    >
                      {ticket.handled_by_name ? (
                        <span className="assigned-user">
                          <FaUserTie />
                          {ticket.handled_by_name}
                        </span>
                      ) : (
                        <span className="unassigned">Unassigned</span>
                      )}
                    </div>
                    <div
                      className="ticket-cell date"
                      onClick={() => handleViewTicket(ticket.id)}
                    >
                      {formatDateShort(ticket.created_at)}
                    </div>
                    <div className="ticket-cell actions">
                      <div className="action-buttons">
                        <button
                          className="action-btn view"
                          onClick={(e) => {
                            e.stopPropagation();
                            handleViewTicket(ticket.id);
                          }}
                          title="View Details"
                        >
                          <FaEye />
                        </button>
                        <button
                          className="action-btn assign"
                          onClick={(e) => {
                            e.stopPropagation();
                            handleAssignToMe(ticket.id);
                          }}
                          disabled={assigning && assigningTicketId === ticket.id}
                          title="Assign to Me"
                        >
                          {assigning && assigningTicketId === ticket.id ? (
                            <FaSpinner className="spinner" />
                          ) : (
                            <FaUserCheck />
                          )}
                        </button>
                        <div className="status-dropdown-wrapper">
                          <select
                            className="status-quick-select"
                            value={ticket.status}
                            onChange={(e) => {
                              e.stopPropagation();
                              handleStatusChange(e.target.value, ticket.id);
                            }}
                            style={{ borderColor: getStatusColor(ticket.status) }}
                          >
                            {STATUSES.map((status) => (
                              <option key={status.value} value={status.value}>
                                {status.icon} {status.label}
                              </option>
                            ))}
                          </select>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>

          {/* Mobile Card View */}
          <div className="ticket-card-view mobile-view">
            {currentItems.length === 0 ? (
              <div className="empty-state">
                <FaTicketAlt />
                <h3>No tickets found</h3>
                <p>No tickets match your current filter criteria.</p>
              </div>
            ) : (
              currentItems.map((ticket) => (
                <div
                  key={ticket.id}
                  className="ticket-card-mobile"
                  onClick={() => handleViewTicket(ticket.id)}
                >
                  <div className="card-header">
                    <div className="card-left">
                      <span className="ticket-number">{ticket.ticket_number}</span>
                      <span className={`status-dot ${ticket.status}`} />
                    </div>
                    <div className="card-right">
                      <span className={getPriorityBadge(ticket.priority)}>
                        {ticket.priority}
                      </span>
                    </div>
                  </div>
                  <div className="card-body">
                    <h4 className="ticket-subject">{ticket.subject}</h4>
                    <div className="ticket-meta">
                      <span className="meta-item">
                        <FaUser />
                        {ticket.created_by_name || 'Unknown'}
                      </span>
                      <span className="meta-item">
                        <FaTag />
                        {getCategoryLabel(ticket.category)}
                      </span>
                      <span className="meta-item">
                        <FaCalendarAlt />
                        {formatDateShort(ticket.created_at)}
                      </span>
                    </div>
                  </div>
                  <div className="card-footer">
                    <span className={getStatusBadge(ticket.status)}>
                      {getStatusLabel(ticket.status)}
                    </span>
                    <div className="card-actions">
                      <button
                        className="action-btn assign"
                        onClick={(e) => {
                          e.stopPropagation();
                          handleAssignToMe(ticket.id);
                        }}
                        disabled={assigning && assigningTicketId === ticket.id}
                        title="Assign to Me"
                      >
                        {assigning && assigningTicketId === ticket.id ? (
                          <FaSpinner className="spinner" />
                        ) : (
                          <FaUserCheck />
                        )}
                      </button>
                      <button
                        className="action-btn view"
                        onClick={(e) => {
                          e.stopPropagation();
                          handleViewTicket(ticket.id);
                        }}
                        title="View Details"
                      >
                        <FaEye />
                      </button>
                    </div>
                  </div>
                </div>
              ))
            )}
          </div>

          {totalPages > 1 && (
            <div className="pagination">
              <button
                className="page-btn"
                onClick={() => setCurrentPage(currentPage - 1)}
                disabled={currentPage === 1}
              >
                <FaChevronLeft />
              </button>
              <span className="page-info">
                Page {currentPage} of {totalPages} ({filteredTickets.length} tickets)
              </span>
              <button
                className="page-btn"
                onClick={() => setCurrentPage(currentPage + 1)}
                disabled={currentPage === totalPages}
              >
                <FaChevronRight />
              </button>
            </div>
          )}
        </div>
      </>
    );
  };

  // ─── Render Contact Form Tickets ────────────
  const renderContactTickets = () => {
    if (isContactLoading && contactTickets.length === 0) {
      return (
        <div className="loading-container">
          <FaSpinner className="spinner" />
          <p>Loading contact form tickets...</p>
        </div>
      );
    }

    return (
      <>
        {/* Filters */}
        <div className="filters-container">
          <div className="search-box">
            <FaSearch className="search-icon" />
            <input
              type="text"
              placeholder="Search by name, email, ticket ID..."
              value={contactSearchTerm}
              onChange={(e) => setContactSearchTerm(e.target.value)}
            />
          </div>
          <div className="filter-group">
            <div className="filter-item">
              <FaFilter className="filter-icon" />
              <select
                value={contactStatusFilter}
                onChange={(e) => setContactStatusFilter(e.target.value)}
                className="filter-select"
              >
                <option value="all">All Status</option>
                {CONTACT_STATUSES.map((status) => (
                  <option key={status.value} value={status.value}>
                    {status.label}
                  </option>
                ))}
              </select>
            </div>
          </div>
        </div>

        {/* Stats */}
        {contactStats && (
          <div className="contact-stats-grid">
            <div className="stat-card total">
              <div className="stat-icon-wrapper">
                <div className="stat-icon"><FaEnvelope /></div>
              </div>
              <div className="stat-info">
                <div className="stat-number">{contactStats.total}</div>
                <div className="stat-label">Total</div>
              </div>
            </div>
            <div className="stat-card pending">
              <div className="stat-icon-wrapper">
                <div className="stat-icon"><FaClock /></div>
              </div>
              <div className="stat-info">
                <div className="stat-number">{contactStats.pending}</div>
                <div className="stat-label">Pending</div>
              </div>
            </div>
            <div className="stat-card in-progress">
              <div className="stat-icon-wrapper">
                <div className="stat-icon"><FaSpinner /></div>
              </div>
              <div className="stat-info">
                <div className="stat-number">{contactStats.in_progress}</div>
                <div className="stat-label">In Progress</div>
              </div>
            </div>
            <div className="stat-card resolved">
              <div className="stat-icon-wrapper">
                <div className="stat-icon"><FaCheckCircle /></div>
              </div>
              <div className="stat-info">
                <div className="stat-number">{contactStats.resolved}</div>
                <div className="stat-label">Resolved</div>
              </div>
            </div>
            <div className="stat-card closed">
              <div className="stat-icon-wrapper">
                <div className="stat-icon"><FaTimes /></div>
              </div>
              <div className="stat-info">
                <div className="stat-number">{contactStats.closed}</div>
                <div className="stat-label">Closed</div>
              </div>
            </div>
            <div className="stat-card last-week">
              <div className="stat-icon-wrapper">
                <div className="stat-icon"><FaCalendarAlt /></div>
              </div>
              <div className="stat-info">
                <div className="stat-number">{contactStats.last_7_days}</div>
                <div className="stat-label">Last 7 Days</div>
              </div>
            </div>
          </div>
        )}

        {/* Contact Ticket List */}
        <div className="ticket-list-container">
          {/* Desktop Table View */}
          <div className="ticket-table-wrapper desktop-view">
            <div className="ticket-list-header contact-header">
              <div className="header-cell status">Status</div>
              <div className="header-cell ticket">Ticket ID</div>
              <div className="header-cell user">Name</div>
              <div className="header-cell email">Email</div>
              <div className="header-cell phone">Phone</div>
              <div className="header-cell message">Message</div>
              <div className="header-cell date">Date</div>
              <div className="header-cell actions">Actions</div>
            </div>

            {contactCurrentItems.length === 0 ? (
              <div className="empty-state">
                <FaEnvelope />
                <h3>No contact form submissions</h3>
                <p>No messages match your current filter criteria.</p>
              </div>
            ) : (
              <div className="ticket-list">
                {contactCurrentItems.map((ticket) => (
                  <div key={ticket.ticket_id} className="ticket-item contact-item">
                    <div className="ticket-cell status">
                      <span
                        className="status-dot"
                        style={{ backgroundColor: getContactStatusColor(ticket.status) }}
                      />
                      <span className={getStatusBadge(ticket.status)}>
                        {getStatusLabel(ticket.status)}
                      </span>
                    </div>
                    <div
                      className="ticket-cell ticket"
                      onClick={() => handleViewContactTicket(ticket.ticket_id)}
                    >
                      <div className="ticket-number">{ticket.ticket_id}</div>
                    </div>
                    <div
                      className="ticket-cell user"
                      onClick={() => handleViewContactTicket(ticket.ticket_id)}
                    >
                      <div className="user-info">
                        <FaUser />
                        <span>{ticket.full_name || `${ticket.first_name} ${ticket.last_name}`}</span>
                      </div>
                    </div>
                    <div
                      className="ticket-cell email"
                      onClick={() => handleViewContactTicket(ticket.ticket_id)}
                    >
                      <a href={`mailto:${ticket.email}`} onClick={(e) => e.stopPropagation()}>
                        {ticket.email}
                      </a>
                    </div>
                    <div
                      className="ticket-cell phone"
                      onClick={() => handleViewContactTicket(ticket.ticket_id)}
                    >
                      <a href={`tel:${ticket.phone}`} onClick={(e) => e.stopPropagation()}>
                        {ticket.phone}
                      </a>
                    </div>
                    <div
                      className="ticket-cell message"
                      onClick={() => handleViewContactTicket(ticket.ticket_id)}
                    >
                      <div className="message-preview">{ticket.message_preview || ticket.message?.substring(0, 50) + '...'}</div>
                    </div>
                    <div
                      className="ticket-cell date"
                      onClick={() => handleViewContactTicket(ticket.ticket_id)}
                    >
                      {formatDateShort(ticket.created_at)}
                    </div>
                    <div className="ticket-cell actions">
                      <div className="action-buttons">
                        <button
                          className="action-btn view"
                          onClick={() => handleViewContactTicket(ticket.ticket_id)}
                          title="View Details"
                        >
                          <FaEye />
                        </button>
                        <div className="status-dropdown-wrapper">
                          <select
                            className="status-quick-select"
                            value={ticket.status}
                            onChange={(e) => {
                              e.stopPropagation();
                              handleContactStatusChange(e.target.value, ticket.ticket_id);
                            }}
                            style={{ borderColor: getContactStatusColor(ticket.status) }}
                          >
                            {CONTACT_STATUSES.map((status) => (
                              <option key={status.value} value={status.value}>
                                {status.icon} {status.label}
                              </option>
                            ))}
                          </select>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>

          {/* Mobile Card View for Contact */}
          <div className="ticket-card-view mobile-view">
            {contactCurrentItems.length === 0 ? (
              <div className="empty-state">
                <FaEnvelope />
                <h3>No contact form submissions</h3>
                <p>No messages match your current filter criteria.</p>
              </div>
            ) : (
              contactCurrentItems.map((ticket) => (
                <div
                  key={ticket.ticket_id}
                  className="ticket-card-mobile contact-card"
                  onClick={() => handleViewContactTicket(ticket.ticket_id)}
                >
                  <div className="card-header">
                    <div className="card-left">
                      <span className="ticket-number">{ticket.ticket_id}</span>
                      <span className={`status-dot ${ticket.status}`} />
                    </div>
                    <div className="card-right">
                      <span className={getStatusBadge(ticket.status)}>
                        {getStatusLabel(ticket.status)}
                      </span>
                    </div>
                  </div>
                  <div className="card-body">
                    <h4 className="ticket-subject">
                      {ticket.full_name || `${ticket.first_name} ${ticket.last_name}`}
                    </h4>
                    <div className="ticket-meta">
                      <span className="meta-item">
                        <FaEnvelope />
                        {ticket.email}
                      </span>
                      <span className="meta-item">
                        <FaPhone />
                        {ticket.phone}
                      </span>
                      <span className="meta-item">
                        <FaCalendarAlt />
                        {formatDateShort(ticket.created_at)}
                      </span>
                    </div>
                    <div className="message-preview-full">
                      {ticket.message_preview || ticket.message?.substring(0, 100) + '...'}
                    </div>
                  </div>
                  <div className="card-footer">
                    <span className="meta-item">
                      <FaReply />
                      {ticket.admin_reply ? 'Replied' : 'No reply yet'}
                    </span>
                    <div className="card-actions">
                      <button
                        className="action-btn view"
                        onClick={(e) => {
                          e.stopPropagation();
                          handleViewContactTicket(ticket.ticket_id);
                        }}
                        title="View Details"
                      >
                        <FaEye />
                      </button>
                    </div>
                  </div>
                </div>
              ))
            )}
          </div>

          {contactTotalPages > 1 && (
            <div className="pagination">
              <button
                className="page-btn"
                onClick={() => setContactCurrentPage(contactCurrentPage - 1)}
                disabled={contactCurrentPage === 1}
              >
                <FaChevronLeft />
              </button>
              <span className="page-info">
                Page {contactCurrentPage} of {contactTotalPages} ({filteredContactTickets.length} tickets)
              </span>
              <button
                className="page-btn"
                onClick={() => setContactCurrentPage(contactCurrentPage + 1)}
                disabled={contactCurrentPage === contactTotalPages}
              >
                <FaChevronRight />
              </button>
            </div>
          )}
        </div>
      </>
    );
  };

  // ─── Render Contact Ticket Detail Modal ─────
  // const renderContactTicketModal = () => {
  //   if (!showContactTicketDetails || !selectedContactTicket) return null;

  //   const ticket = selectedContactTicket;

  //   return (
  //     <div className="modal-overlay">
  //       <div className="modal-content ticket-details-modal">
  //         <div className="modal-header">
  //           <div className="header-left">
  //             <div className="ticket-id">
  //               <FaEnvelope />
  //               <span>{ticket.ticket_id}</span>
  //             </div>
  //             <div className="ticket-status-badges">
  //               <span className={getStatusBadge(ticket.status)}>
  //                 {getStatusLabel(ticket.status)}
  //               </span>
  //             </div>
  //           </div>
  //           <div className="header-actions">
  //             <button className="close-modal" onClick={handleCloseContactTicketDetails}>
  //               <FaTimes />
  //             </button>
  //           </div>
  //         </div>

  //         <div className="modal-tabs mobile-tabs">
  //           <button
  //             className={`tab-btn ${mobileDetailTab === 'details' ? 'active' : ''}`}
  //             onClick={() => setMobileDetailTab('details')}
  //           >
  //             <FaInfoCircle />
  //             <span>Details</span>
  //           </button>
  //           <button
  //             className={`tab-btn ${mobileDetailTab === 'reply' ? 'active' : ''}`}
  //             onClick={() => setMobileDetailTab('reply')}
  //           >
  //             <FaReply />
  //             <span>Reply</span>
  //           </button>
  //         </div>

  //         <div className="modal-body two-column">
  //           {/* Details Column */}
  //           <div className={`details-column ${mobileDetailTab === 'details' ? 'active' : ''}`}>
  //             <div className="info-card">
  //               <h4 className="card-title"><FaUser /> Customer Information</h4>
  //               <div className="info-grid">
  //                 <div className="info-item">
  //                   <span className="info-label">Full Name</span>
  //                   <span className="info-value">
  //                     {ticket.full_name || `${ticket.first_name} ${ticket.last_name}`}
  //                   </span>
  //                 </div>
  //                 <div className="info-item">
  //                   <span className="info-label">Email</span>
  //                   <span className="info-value">
  //                     <a href={`mailto:${ticket.email}`}>{ticket.email}</a>
  //                   </span>
  //                 </div>
  //                 <div className="info-item">
  //                   <span className="info-label">Phone</span>
  //                   <span className="info-value">
  //                     <a href={`tel:${ticket.phone}`}>{ticket.phone}</a>
  //                   </span>
  //                 </div>
  //                 <div className="info-item">
  //                   <span className="info-label">Ticket ID</span>
  //                   <span className="info-value">{ticket.ticket_id}</span>
  //                 </div>
  //                 <div className="info-item full-width">
  //                   <span className="info-label">Created</span>
  //                   <span className="info-value">{formatDate(ticket.created_at)}</span>
  //                 </div>
  //               </div>
  //             </div>

  //             <div className="info-card">
  //               <h4 className="card-title"><FaComments /> Message</h4>
  //               <div className="info-description">{ticket.message}</div>
  //             </div>

  //             {ticket.admin_reply && (
  //               <div className="info-card">
  //                 <h4 className="card-title"><FaReply /> Admin Reply</h4>
  //                 <div className="info-description admin-reply">{ticket.admin_reply}</div>
  //                 {ticket.replied_at && (
  //                   <p className="reply-meta">
  //                     Replied on {formatDate(ticket.replied_at)}
  //                     {ticket.replied_by_name && ` by ${ticket.replied_by_name}`}
  //                   </p>
  //                 )}
  //               </div>
  //             )}

  //             <div className="info-card">
  //               <h4 className="card-title"><FaCog /> Status</h4>
  //               <div className="status-priority-grid">
  //                 <div className="status-field">
  //                   <span className="info-label">Current Status</span>
  //                   <div className="status-select-wrapper">
  //                     <select
  //                       value={ticket.status}
  //                       onChange={(e) => {
  //                         const newStatus = e.target.value;
  //                         setSelectedContactTicket({ ...ticket, status: newStatus });
  //                         handleContactStatusChange(newStatus, ticket.ticket_id);
  //                       }}
  //                       className="status-select-dropdown"
  //                       style={{ borderColor: getContactStatusColor(ticket.status) }}
  //                     >
  //                       {CONTACT_STATUSES.map((status) => (
  //                         <option key={status.value} value={status.value}>
  //                           {status.icon} {status.label}
  //                         </option>
  //                       ))}
  //                     </select>
  //                     <span
  //                       className="status-indicator"
  //                       style={{ backgroundColor: getContactStatusColor(ticket.status) }}
  //                     />
  //                   </div>
  //                 </div>
  //               </div>
  //             </div>
  //           </div>

  //           {/* Reply Column */}
  //           <div className={`chat-column ${mobileDetailTab === 'reply' ? 'active' : ''}`}>
  //             <div className="chat-header">
  //               <FaReply />
  //               <span>Send Reply to Customer</span>
  //             </div>

  //             <div className="chat-messages contact-reply-messages">
  //               <div className="chat-message user">
  //                 <div className="message-avatar"><FaUser /></div>
  //                 <div className="message-content">
  //                   <div className="message-meta">
  //                     <span className="sender">{ticket.full_name || `${ticket.first_name} ${ticket.last_name}`}</span>
  //                     <span className="time">{formatDate(ticket.created_at)}</span>
  //                   </div>
  //                   <div className="message-text">{ticket.message}</div>
  //                 </div>
  //               </div>

  //               {ticket.admin_reply && (
  //                 <div className="chat-message staff">
  //                   <div className="message-avatar"><FaUserTie /></div>
  //                   <div className="message-content">
  //                     <div className="message-meta">
  //                       <span className="sender">
  //                         <span className="staff-badge">Support</span>
  //                         {ticket.replied_by_name || 'Admin'}
  //                       </span>
  //                       <span className="time">{formatDate(ticket.replied_at)}</span>
  //                     </div>
  //                     <div className="message-text">{ticket.admin_reply}</div>
  //                   </div>
  //                 </div>
  //               )}
  //             </div>

  //             {ticket.status !== "resolved" &&(
  //               <>
  //               <div className="chat-reply">
  //               <div className="reply-input-wrapper">
  //                 <textarea
  //                   value={contactReplyMessage}
  //                   onChange={(e) => setContactReplyMessage(e.target.value)}
  //                   placeholder="Type your reply to the customer..."
  //                   rows="3"
  //                   className="reply-input"
  //                 />
  //                 <button
  //                   className="send-btn"
  //                   onClick={handleSendContactReply}
  //                   disabled={!contactReplyMessage.trim() || contactReplyMessage.trim().length < 10 || isContactSubmitting}
  //                 >
  //                   {isContactSubmitting ? (
  //                     <FaSpinner className="spinner" />
  //                   ) : (
  //                     <FaPaperPlane />
  //                   )}
  //                   Send
  //                 </button>
  //               </div>
  //               <div className="reply-hint">
  //                 <FaRegClock /> Minimum 10 characters. Customer will receive this via email.
  //               </div>
  //             </div>
  //               </>
  //             )}
  //           </div>
  //         </div>
  //       </div>
  //     </div>
  //   );
  // };

  // ─── Render Contact Ticket Detail Modal ─────
const renderContactTicketModal = () => {
  if (!showContactTicketDetails || !selectedContactTicket) return null;

  const ticket = selectedContactTicket;
  const isResolved = ticket.status === 'resolved' || ticket.status === 'closed';

  return (
    <div className="modal-overlay">
      <div className="modal-content ticket-details-modal contact-modal">
        <div className="modal-header">
          <div className="header-left">
            <div className="ticket-id">
              <FaEnvelope />
              <span>{ticket.ticket_id}</span>
            </div>
            <div className="ticket-status-badges">
              <span className={getStatusBadge(ticket.status)}>
                {getStatusLabel(ticket.status)}
              </span>
            </div>
          </div>
          <div className="header-actions">
            <button className="close-modal" onClick={handleCloseContactTicketDetails}>
              <FaTimes />
            </button>
          </div>
        </div>

        <div className="modal-tabs mobile-tabs">
          <button
            className={`tab-btn ${mobileDetailTab === 'details' ? 'active' : ''}`}
            onClick={() => setMobileDetailTab('details')}
          >
            <FaInfoCircle />
            <span>Details</span>
          </button>
          <button
            className={`tab-btn ${mobileDetailTab === 'reply' ? 'active' : ''}`}
            onClick={() => setMobileDetailTab('reply')}
          >
            <FaReply />
            <span>Reply</span>
          </button>
        </div>

        <div className="modal-body two-column">
          {/* Details Column */}
          <div className={`details-column ${mobileDetailTab === 'details' ? 'active' : ''}`}>
            {/* Customer Information */}
            <div className="info-card">
              <h4 className="card-title"><FaUser /> Customer Information</h4>
              <div className="info-grid">
                <div className="info-item">
                  <span className="info-label">Full Name</span>
                  <span className="info-value">
                    {ticket.full_name || `${ticket.first_name} ${ticket.last_name}`}
                  </span>
                </div>
                <div className="info-item">
                  <span className="info-label">Email</span>
                  <span className="info-value">
                    <a href={`mailto:${ticket.email}`}>{ticket.email}</a>
                  </span>
                </div>
                <div className="info-item">
                  <span className="info-label">Phone</span>
                  <span className="info-value">
                    <a href={`tel:${ticket.phone}`}>{ticket.phone}</a>
                  </span>
                </div>
                <div className="info-item">
                  <span className="info-label">Ticket ID</span>
                  <span className="info-value">{ticket.ticket_id}</span>
                </div>
                <div className="info-item full-width">
                  <span className="info-label">Created</span>
                  <span className="info-value">{formatDate(ticket.created_at)}</span>
                </div>
              </div>
            </div>

            {/* Message */}
            <div className="info-card">
              <h4 className="card-title"><FaComments /> Message</h4>
              <div className="info-description">{ticket.message}</div>
            </div>

            {/* Admin Reply */}
            {ticket.admin_reply && (
              <div className="info-card">
                <h4 className="card-title"><FaReply /> Admin Reply</h4>
                <div className="info-description admin-reply">{ticket.admin_reply}</div>
                {ticket.replied_at && (
                  <p className="reply-meta">
                    Replied on {formatDate(ticket.replied_at)}
                    {ticket.replied_by_name && ` by ${ticket.replied_by_name}`}
                  </p>
                )}
              </div>
            )}

            {/* Status */}
            <div className="info-card">
              <h4 className="card-title"><FaCog /> Status</h4>
              <div className="status-priority-grid">
                <div className="status-field">
                  <span className="info-label">Current Status</span>
                  <div className="status-select-wrapper">
                    <select
                      value={ticket.status}
                      onChange={(e) => {
                        const newStatus = e.target.value;
                        setSelectedContactTicket({ ...ticket, status: newStatus });
                        handleContactStatusChange(newStatus, ticket.ticket_id);
                      }}
                      className="status-select-dropdown"
                      style={{ borderColor: getContactStatusColor(ticket.status) }}
                    >
                      {CONTACT_STATUSES.map((status) => (
                        <option key={status.value} value={status.value}>
                          {status.icon} {status.label}
                        </option>
                      ))}
                    </select>
                    <span
                      className="status-indicator"
                      style={{ backgroundColor: getContactStatusColor(ticket.status) }}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Reply Column */}
          <div className={`chat-column ${mobileDetailTab === 'reply' ? 'active' : ''}`}>
            <div className="chat-header">
              <FaReply />
              <span>Send Reply to Customer</span>
            </div>

            <div className="chat-messages contact-reply-messages">
              {/* Customer's original message */}
              <div className="chat-message user">
                <div className="message-avatar"><FaUser /></div>
                <div className="message-content">
                  <div className="message-meta">
                    <span className="sender">
                      {ticket.full_name || `${ticket.first_name} ${ticket.last_name}`}
                    </span>
                    <span className="time">{formatTime(ticket.created_at)}</span>
                  </div>
                  <div className="message-text">{ticket.message}</div>
                </div>
              </div>

              {/* Admin reply if exists */}
              {ticket.admin_reply && (
                <div className="chat-message staff">
                  <div className="message-avatar"><FaUserTie /></div>
                  <div className="message-content">
                    <div className="message-meta">
                      <span className="sender">
                        <span className="staff-badge">Support</span>
                        {ticket.replied_by_name || 'Admin'}
                      </span>
                      <span className="time">{formatTime(ticket.replied_at)}</span>
                    </div>
                    <div className="message-text">{ticket.admin_reply}</div>
                  </div>
                </div>
              )}

              {/* Resolved indicator */}
              {isResolved && (
                <div className="resolved-banner-container">
                  <div className="resolved-banner-content">
                    <FaCheckCircle size={20} color="#10b981" />
                    <span className="resolved-banner-text">
                      This ticket has been {ticket.status}
                    </span>
                  </div>
                </div>
              )}
            </div>

            {/* Reply Input */}
            {!isResolved ? (
              <div className="chat-reply">
                <div className="reply-input-wrapper">
                  <textarea
                    value={contactReplyMessage}
                    onChange={(e) => setContactReplyMessage(e.target.value)}
                    placeholder="Type your reply to the customer..."
                    rows="3"
                    className="reply-input"
                  />
                  <button
                    className="send-btn"
                    onClick={handleSendContactReply}
                    disabled={!contactReplyMessage.trim() || isContactSubmitting}
                  >
                    {isContactSubmitting ? (
                      <FaSpinner className="spinner" />
                    ) : (
                      <FaPaperPlane />
                    )}
                    Send
                  </button>
                </div>
                <div className="reply-hint">
                  <FaRegClock /> Customer will receive this via email
                </div>
              </div>
            ) : (
              <div className="chat-reply resolved">
                <p>
                  <FaCheckCircle /> This ticket is {ticket.status}
                </p>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

  // ─── Main Render ─────────────────────────────
  return (
    <>
      <Nav />
      <div className="admin-helpdesk">
        {/* Header */}
        <div className="admin-header">
          <div className="header-content">
            <div className="header-left">
              <h1>
                <FaTicketAlt /> Help Desk Management
              </h1>
              <p>Manage support tickets and contact form inquiries</p>
            </div>
            
          </div>
        </div>

        {/* Tab Navigation */}
        <div className="tab-navigation">
          <button
            className={`tab-btn ${activeTab === 'support' ? 'active' : ''}`}
            onClick={() => setActiveTab('support')}
          >
            <FaTicketAlt />
            <span>Support Tickets</span>
            {stats && <span className="tab-badge">{stats.total}</span>}
          </button>
          <button
            className={`tab-btn ${activeTab === 'contact' ? 'active' : ''}`}
            onClick={() => setActiveTab('contact')}
          >
            <FaEnvelope />
            <span>Contact Form Tickets</span>
            {contactStats && <span className="tab-badge">{contactStats.total}</span>}
          </button>
        </div>

        {/* Stats Dashboard - Support */}
        {activeTab === 'support' && stats && (
          <div className="stats-support">
            <div className="stats-grid">
              <div className="stat-card total">
                <div className="stat-icon-wrapper">
                  <div className="stat-icon"><FaTicketAlt /></div>
                </div>
                <div className="stat-info">
                  <div className="stat-number">{stats.total}</div>
                  <div className="stat-label">Total Tickets</div>
                </div>
              </div>
              <div className="stat-card open">
                <div className="stat-icon-wrapper">
                  <div className="stat-icon"><FaCircle /></div>
                </div>
                <div className="stat-info">
                  <div className="stat-number">{stats.open}</div>
                  <div className="stat-label">Open</div>
                </div>
              </div>
              <div className="stat-card pending">
                <div className="stat-icon-wrapper">
                  <div className="stat-icon"><FaClock /></div>
                </div>
                <div className="stat-info">
                  <div className="stat-number">{stats.pending}</div>
                  <div className="stat-label">Pending</div>
                </div>
              </div>
              <div className="stat-card resolved">
                <div className="stat-icon-wrapper">
                  <div className="stat-icon"><FaCheckCircle /></div>
                </div>
                <div className="stat-info">
                  <div className="stat-number">{stats.resolved}</div>
                  <div className="stat-label">Resolved</div>
                </div>
              </div>
              <div className="stat-card high-priority">
                <div className="stat-icon-wrapper">
                  <div className="stat-icon"><FaExclamationCircle /></div>
                </div>
                <div className="stat-info">
                  <div className="stat-number">{stats.high_priority}</div>
                  <div className="stat-label">High Priority</div>
                </div>
              </div>
              <div className="stat-card unassigned">
                <div className="stat-icon-wrapper">
                  <div className="stat-icon"><FaUserPlus /></div>
                </div>
                <div className="stat-info">
                  <div className="stat-number">{stats.unassigned}</div>
                  <div className="stat-label">Unassigned</div>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* Render Content based on active tab */}
        {activeTab === 'support' ? renderSupportTickets() : renderContactTickets()}

        {/* Ticket Detail Modal - Support */}
        {showTicketDetails && selectedTicket && (
          <div className="modal-overlay">
            <div className="modal-content ticket-details-modal">
              <div className="modal-header">
                <div className="header-left">
                  <div className="ticket-id">
                    <FaTicketAlt />
                    <span>{selectedTicket.ticket_number}</span>
                    {chatNewMessagesCount > 0 && (
                      <span className="new-messages-indicator">{chatNewMessagesCount} new</span>
                    )}
                  </div>
                  <div className="ticket-status-badges">
                    <span className={getStatusBadge(selectedTicket.status)}>
                      {getStatusLabel(selectedTicket.status)}
                    </span>
                    <span className={getPriorityBadge(selectedTicket.priority)}>
                      {selectedTicket.priority}
                    </span>
                  </div>
                </div>
                <div className="header-actions">
                  <button className="close-modal" onClick={handleCloseTicketDetails}>
                    <FaTimes />
                  </button>
                </div>
              </div>

              <div className="modal-tabs mobile-tabs">
                <button
                  className={`tab-btn ${mobileDetailTab === 'details' ? 'active' : ''}`}
                  onClick={() => setMobileDetailTab('details')}
                >
                  <FaInfoCircle />
                  <span>Details</span>
                </button>
                <button
                  className={`tab-btn ${mobileDetailTab === 'conversation' ? 'active' : ''}`}
                  onClick={() => {
                    setMobileDetailTab('conversation');
                    setChatNewMessagesCount(0);
                  }}
                >
                  <FaCommentsIcon />
                  <span>Conversation</span>
                  {chatNewMessagesCount > 0 && (
                    <span className="tab-badge pulse">{chatNewMessagesCount}</span>
                  )}
                </button>
              </div>

              <div className="modal-body two-column">
                {/* Details Column */}
                <div className={`details-column ${mobileDetailTab === 'details' ? 'active' : ''}`}>
                  <div className="info-card">
                    <h4 className="card-title">Ticket Information</h4>
                    <div className="info-grid">
                      <div className="info-item">
                        <span className="info-label">Issue Type</span>
                        <span className={`issue-type-badge ${selectedTicket.issue_type}`}>
                          {getIssueTypeLabel(selectedTicket.issue_type)}
                        </span>
                      </div>
                      <div className="info-item">
                        <span className="info-label">Category</span>
                        <span className="info-value">
                          {getCategoryLabel(selectedTicket.category)}
                        </span>
                      </div>
                      <div className="info-item full-width">
                        <span className="info-label">Subject</span>
                        <span className="info-value">{selectedTicket.subject}</span>
                      </div>
                      <div className="info-item full-width">
                        <span className="info-label">Description</span>
                        <div className="info-description">{selectedTicket.description}</div>
                      </div>
                    </div>
                  </div>

                  <div className="info-card status-card">
                    <h4 className="card-title"><FaCog /> Status & Priority</h4>
                    <div className="status-priority-grid">
                      <div className="status-field">
                        <span className="info-label">Current Status</span>
                        <div className="status-select-wrapper">
                          <select
                            value={selectedTicket.status}
                            onChange={(e) => {
                              const newStatus = e.target.value;
                              setSelectedTicket({ ...selectedTicket, status: newStatus });
                              handleStatusChange(newStatus, selectedTicket.id);
                            }}
                            className="status-select-dropdown"
                            style={{ borderColor: getStatusColor(selectedTicket.status) }}
                          >
                            {STATUSES.map((status) => (
                              <option key={status.value} value={status.value}>
                                {status.icon} {status.label}
                              </option>
                            ))}
                          </select>
                          <span
                            className="status-indicator"
                            style={{ backgroundColor: getStatusColor(selectedTicket.status) }}
                          />
                        </div>
                      </div>
                      <div className="priority-field">
                        <span className="info-label">Priority</span>
                        <span className={`priority-display ${getPriorityBadge(selectedTicket.priority)}`}>
                          {selectedTicket.priority}
                        </span>
                      </div>
                    </div>
                  </div>

                  <div className="info-card">
                    <div className="info-grid">
                      <div className="info-item">
                        <span className="info-label">Created</span>
                        <span className="info-value">
                          <FaCalendarAlt className="info-icon" />
                          {formatDate(selectedTicket.created_at)}
                        </span>
                      </div>
                      <div className="info-item">
                        <span className="info-label">Last Updated</span>
                        <span className="info-value">
                          <FaCalendarAlt className="info-icon" />
                          {formatDate(selectedTicket.updated_at)}
                        </span>
                      </div>
                      <div className="info-item">
                        <span className="info-label">Phone</span>
                        <span className="info-value">
                          <FaPhone className="info-icon" />
                          {selectedTicket.created_by_phone_number || 'N/A'}
                        </span>
                      </div>
                      <div className="info-item">
                        <span className="info-label">Created By</span>
                        <span className="info-value">
                          <FaUser className="info-icon" />
                          {selectedTicket.created_by_name || 'Unknown'}
                        </span>
                      </div>
                      {selectedTicket.handled_by && (
                        <div className="info-item">
                          <span className="info-label">Handled By</span>
                          <span className="info-value">
                            <FaUserTie className="info-icon" />
                            {selectedTicket.handled_by_name || 'Staff'}
                          </span>
                        </div>
                      )}
                      {selectedTicket.resolved_at && (
                        <div className="info-item">
                          <span className="info-label">Resolved</span>
                          <span className="info-value">
                            <FaCheckCircle className="info-icon resolved" />
                            {formatDate(selectedTicket.resolved_at)}
                          </span>
                        </div>
                      )}
                    </div>
                  </div>

                  {selectedTicket.attachments && selectedTicket.attachments.length > 0 && (
                    <div className="info-card">
                      <h4 className="card-title">
                        <FaPaperclip /> Attachments ({selectedTicket.attachments.length})
                      </h4>
                      <div className="attachments-grid">
                        {selectedTicket.attachments.map((attachment) => {
                          const filename = attachment.file.split('/').pop();
                          const fileInfo = getFileTypeInfo(filename);
                          const FileIcon = fileInfo.icon;
                          const isImage = fileInfo.type === 'image';

                          return (
                            <div
                              key={attachment.id}
                              className="attachment-preview-card"
                              onClick={() => handleAttachmentClick(attachment.file, filename)}
                            >
                              <div className="attachment-thumbnail">
                                {isImage ? (
                                  <img src={attachment.file} alt={filename} />
                                ) : (
                                  <div className={`file-icon ${fileInfo.type}`}>
                                    <FileIcon />
                                  </div>
                                )}
                                <div className="attachment-overlay">
                                  <FaExpand />
                                </div>
                              </div>
                              <div className="attachment-info">
                                <span className="filename">{filename}</span>
                                <span className="file-type">{fileInfo.label}</span>
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  )}
                </div>

                {/* Conversation Column */}
                <div className={`chat-column ${mobileDetailTab === 'conversation' ? 'active' : ''}`}>
                  <div className="chat-header">
                    <FaComments />
                    <span>Conversation</span>
                    {chatNewMessagesCount > 0 && (
                      <span className="new-messages-indicator">{chatNewMessagesCount} new</span>
                    )}
                    <span className="message-count">
                      ({selectedTicket.replies ? selectedTicket.replies.length + 1 : 1})
                    </span>
                  </div>

                  <div className="chat-messages">
                    {selectedTicket.description && (
                      <div className="chat-message user">
                        <div className="message-avatar"><FaUser /></div>
                        <div className="message-content">
                          <div className="message-meta">
                            <span className="sender">{selectedTicket.created_by_name || 'User'}</span>
                            <span className="time">{formatDate(selectedTicket.created_at)}</span>
                          </div>
                          <div className="message-text">{selectedTicket.description}</div>
                        </div>
                      </div>
                    )}

                    {selectedTicket.replies &&
                      selectedTicket.replies.map((reply) => (
                        <div
                          key={reply.id}
                          className={`chat-message ${reply.is_staff_reply ? 'staff' : 'user'}`}
                        >
                          <div className="message-avatar">
                            {reply.is_staff_reply ? (
                              <FaUserTie className="staff-avatar" />
                            ) : (
                              <FaUser />
                            )}
                          </div>
                          <div className="message-content">
                            <div className="message-meta">
                              <span className="sender">
                                {reply.is_staff_reply ? (
                                  <>
                                    <span className="staff-badge">Support</span>
                                    {reply.sender_name || 'Staff'}
                                  </>
                                ) : (
                                  reply.sender_name || 'User'
                                )}
                              </span>
                              <span className="time">{formatDate(reply.created_at)}</span>
                            </div>
                            <div className="message-text">{reply.message}</div>
                            {reply.attachments && reply.attachments.length > 0 && (
                              <div className="message-attachments-grid">
                                {reply.attachments.map((att) => {
                                  const filename = att.file.split('/').pop();
                                  const fileInfo = getFileTypeInfo(filename);
                                  const FileIcon = fileInfo.icon;
                                  const isImage = fileInfo.type === 'image';

                                  return (
                                    <div
                                      key={att.id}
                                      className="message-attachment-preview"
                                      onClick={() => handleAttachmentClick(att.file, filename)}
                                    >
                                      {isImage ? (
                                        <img src={att.file} alt={filename} />
                                      ) : (
                                        <FileIcon />
                                      )}
                                      <span>{filename}</span>
                                    </div>
                                  );
                                })}
                              </div>
                            )}
                          </div>
                        </div>
                      ))}
                  </div>

                  <div className="chat-reply">
                    <div className="reply-input-wrapper">
                      <textarea
                        value={newMessage}
                        onChange={(e) => setNewMessage(e.target.value)}
                        placeholder="Type your reply..."
                        rows="2"
                        className="reply-input"
                        onKeyDown={(e) => {
                          if (e.key === 'Enter' && !e.shiftKey) {
                            e.preventDefault();
                            handleSendReply();
                          }
                        }}
                      />
                      <button
                        className="send-btn"
                        onClick={handleSendReply}
                        disabled={!newMessage.trim() || isSubmitting}
                      >
                        {isSubmitting ? <FaSpinner className="spinner" /> : <FaPaperPlane />}
                        Send
                      </button>
                    </div>
                    <div className="reply-hint">
                      <FaRegClock /> Press Enter to send, Shift+Enter for new line
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* Contact Ticket Modal */}
        {renderContactTicketModal()}

        {/* Attachment Preview Modal */}
        {showAttachmentPreview && selectedAttachment && (
          <div className="attachment-preview-overlay" onClick={handleCloseAttachmentPreview}>
            <div className="attachment-preview-content" onClick={(e) => e.stopPropagation()}>
              <div className="attachment-preview-header">
                <span className="attachment-preview-filename">
                  <FaPaperclip />
                  {selectedAttachment.filename}
                </span>
                <button className="attachment-preview-close" onClick={handleCloseAttachmentPreview}>
                  <FaTimes />
                </button>
              </div>
              <div className="attachment-preview-body">
                {getFileTypeInfo(selectedAttachment.filename).type === 'image' ? (
                  <img
                    src={selectedAttachment.url}
                    alt={selectedAttachment.filename}
                    className="attachment-preview-image"
                  />
                ) : (
                  <div className="attachment-preview-file">
                    <div className="preview-file-icon">
                      {(() => {
                        const FileIcon = getFileTypeInfo(selectedAttachment.filename).icon;
                        return <FileIcon />;
                      })()}
                    </div>
                    <p className="preview-file-name">{selectedAttachment.filename}</p>
                    <p className="preview-file-hint">Click to download or open</p>
                    <a
                      href={selectedAttachment.url}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="preview-file-download"
                    >
                      <FaDownload /> Open File
                    </a>
                  </div>
                )}
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default withauth(AdminHelpDesk, 'admin');